import type { SVGProps } from "react";

import { cn } from "@/utils/cn";

type IconProps = SVGProps<SVGSVGElement>;

export const Calendar = ({ className, ...props }: IconProps) => (
  <svg
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    {...props}
    className={cn("size-ds-icon-base", className)}
  >
    <path
      d="M13 2.25H11.5V1.75C11.5 1.61739 11.4473 1.49021 11.3536 1.39645C11.2598 1.30268 11.1326 1.25 11 1.25C10.8674 1.25 10.7402 1.30268 10.6464 1.39645C10.5527 1.49021 10.5 1.61739 10.5 1.75V2.25H5.5V1.75C5.5 1.61739 5.44732 1.49021 5.35355 1.39645C5.25979 1.30268 5.13261 1.25 5 1.25C4.86739 1.25 4.74021 1.30268 4.64645 1.39645C4.55268 1.49021 4.5 1.61739 4.5 1.75V2.25H3C2.73478 2.25 2.48043 2.35536 2.29289 2.54289C2.10536 2.73043 2 2.98478 2 3.25V13.25C2 13.5152 2.10536 13.7696 2.29289 13.9571C2.48043 14.1446 2.73478 14.25 3 14.25H13C13.2652 14.25 13.5196 14.1446 13.7071 13.9571C13.8946 13.7696 14 13.5152 14 13.25V3.25C14 2.98478 13.8946 2.73043 13.7071 2.54289C13.5196 2.35536 13.2652 2.25 13 2.25ZM4.5 3.25V3.75C4.5 3.88261 4.55268 4.00978 4.64645 4.10355C4.74021 4.19732 4.86739 4.25 5 4.25C5.13261 4.25 5.25979 4.19732 5.35355 4.10355C5.44732 4.00978 5.5 3.88261 5.5 3.75V3.25H10.5V3.75C10.5 3.88261 10.5527 4.00978 10.6464 4.10355C10.7402 4.19732 10.8674 4.25 11 4.25C11.1326 4.25 11.2598 4.19732 11.3536 4.10355C11.4473 4.00978 11.5 3.88261 11.5 3.75V3.25H13V5.25H3V3.25H4.5ZM13 13.25H3V6.25H13V13.25Z"
      fill="currentColor"
    />
  </svg>
);
